import localforage from "localforage"
const InitLocalStoreWrapper = () => {
    localforage.config({
        name: "candexAppStorage", // Name of the database
        storeName: "candexDataStore", // Name of the data store
        version: 1.0, // Database version
        description: "Local storage for candex web app", // Description for the database
        driver: [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE] // Preferred storage drivers in order
    });
}

const get = async (key) => {
    const value = await localforage.getItem(key);
    return value;
}
const set = async (key, value) => {
    await localforage.setItem(key, value);
}
const remove = async (key) => {
    await localforage.removeItem(key);
}
window.CXLocalStore = {
    get: get,
    set: set,
    remove: remove,
    InitLocalStoreWrapper: InitLocalStoreWrapper,
    localforage: localforage
};
